import { AiWorkflow } from '../../types/content';

/** AI workflow 섹션. 한계를 최소 한 줄 이상 정직하게 쓴다. 서술 문장은 합쇼체. */
export const aiWorkflow: AiWorkflow = {
  headline: 'AI를 일에 넣는 방식',
  intro:
    'AI로 무엇이 달라졌는지는 케이스 C(AI 분석 보고서)에 있습니다. 여기서는 AI를 일에 넣을 때 무엇을 지키는지만 씁니다.',
  caseId: 'C',
  how:
    '핵심은 모델이 아니라 맥락과 하네스입니다. 지표 정의·계보·해석 규칙을 담은 데이터 맵으로 데이터를 맥락화하고, AI가 그 맥락 안에서만 읽고 쓰게 하는 하네스를 둡니다. 설계는 AI와 대화하며 하고, 무엇을 지킬지는 제가 정합니다.',
  summary:
    '추론은 "추정"으로 표기하고, 예시값은 실값이 아닌 합성 데이터로 쓰고, 사람은 부서 단위로만 다룹니다. 에이전트는 DW에 직접 붙지 않습니다. AI는 속도를 올리고, 지킬 것은 제가 정합니다.',
  guardrails: [
    {
      title: '추론은 "추정"으로 표기합니다',
      description: 'LLM이 생성한 테이블 설명과 관계는 검수된 것과 시각적으로 구분합니다. 카탈로그가 새로운 오해의 원천이 되지 않게 하기 위해서입니다.'
    },
    {
      title: '예시값은 합성 데이터만 씁니다',
      description: '직렬화 구조는 실제 코드에서 재현하되, 값과 ID는 전부 가짜입니다. 문서가 데이터 유출 경로가 되지 않게 합니다.'
    },
    {
      title: '사람은 부서 단위로만 다룹니다',
      description: '누가 어떤 데이터를 보는지는 조직 단위로 집계합니다. 개인 식별정보는 파이프라인에 들어오지 않습니다.'
    },
    {
      title: '에이전트는 DW에 직접 붙지 않습니다',
      description: '읽기 전용, 파티션 필터 필수, 결과는 로컬에서 집계합니다. 비용과 노출의 경계를 사람의 주의력이 아니라 래퍼가 지킵니다.'
    },
    {
      title: '승인이 필요한 일은 멈추고 묻습니다',
      description: '운영 환경 접근, 파괴적 명령, 외부 전송은 자동 승인 모드에서도 사람의 확인을 거칩니다.'
    }
  ],
  limitations: [
    'AI 분석 보고서는 해석을 보조하지만 판단을 대체하지는 않습니다. 보고서가 그럴듯할수록 검증 없이 인용될 위험이 커지므로, 운영 반영은 반드시 소비 조직과 협의를 거칩니다.',
    '추론과 검수를 구분하지 않으면 카탈로그 자체가 새로운 오해의 원천이 됩니다. 그래서 "추정" 표기를 강제했습니다.',
    '애매한 데이터는 애매한 추론을 낳습니다. 입력에 사실이 아니라 해석이 섞인 파생 데이터가 있었습니다. 성과가 유리하게 보이도록 구성된 것이었는데, AI가 이를 쓰자 응답이 사실 데이터의 나열과 크게 어긋나는 경우가 많았습니다. 응답을 JSON 키로 구조화해 항목마다 사실 데이터와 재검증하는 단계를 넣었고, 이후에는 그 데이터를 아예 배제하고 검증된 사실 데이터로 갈아 끼워 해결했습니다.'
  ],
  diagram: `flowchart LR
  H[사람 · 질문과 판단] --> AG[코딩 에이전트]
  AG --> W[쿼리 · 스키마 래퍼<br/>읽기 전용 · 파티션 가드]
  W --> DW[(DW)]
  DW --> L[로컬 집계 · 요약만 컨텍스트에]
  L --> H
  SRC[코드 · DDL · 사용 로그] --> X[LLM 추출]
  X --> T{검수됨?}
  T -->|예| KG[지식 그래프 · 확정]
  T -->|아니오| KG2[지식 그래프 · 추정 표기]
  KG & KG2 --> MAP[정적 데이터 맵]`
};
